import { render, staticRenderFns } from "./edit-purchase.vue?vue&type=template&id=6d1823a6&scoped=true"
import script from "./edit-purchase.vue?vue&type=script&lang=js"
export * from "./edit-purchase.vue?vue&type=script&lang=js"
import style0 from "./edit-purchase.vue?vue&type=style&index=0&id=6d1823a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1823a6",
  null
  
)

export default component.exports